import { trim } from '@/support/String';
import { Config } from '@/support/Config';
import client from '@/support/Clients/Client';
import { AxiosResponse } from 'axios';

export const createOauthAccessToken = (payload: OauthPayload): Promise<AxiosResponse> => {
  const oauthPayload: OauthPayload = { ...{
    grant_type: 'password',
    client_id: '1',
    client_secret: 'secret',
    scope: '*',
  },
  ...payload };

  const oauthHeaders: {[key:string]: string} = {
    Accept: 'application/json',
  };
  const oauthHost = Config.get('APP_HOST_OAUTH') as string;
  const apiOauth = `${trim('/', oauthHost)}/token`;
  return client('POST', oauthHeaders, apiOauth, oauthPayload);
};

export interface OauthPayload {
  grant_type?: 'password';
  client_id?: string;
  client_secret?: string;
  scope?: string;
  username?: string;
  password?: string;
  token?: string;
}
